const BlogCard = {
  parts: [
    'blogPost',
    'blogImageContainer',
    'blogImage',
    'blogContent',
    'blogCategory',
    'blogTitle',
    'blogTags',
    'blogTag',
    'blogTagText'
  ],
  baseStyle: {
    blogPost: {
      display: 'flex',
      px: {base: 5, md: 0}, // 20px mobile, 0 desktop
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 6}, // 16px mobile, 24px desktop
      alignSelf: 'stretch',
      flex: '1 0 0',
      transition: 'transform 0.2s ease',
      _hover: {
        transform: 'translateY(-2px)',
      },
    },
    blogImageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
      aspectRatio: {base: '67/60', md: '1/1'}, // Figma mobile aspect ratio
      overflow: 'hidden',
    },
    blogImage: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
    },
    blogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 2}, // 16px mobile, 8px desktop
      alignSelf: 'stretch',
    },
    blogCategory: {
      alignSelf: 'stretch',
      color: 'brandColors.primaryDarkLinen', // #8C683B
      fontFamily: 'heading',
      fontSize: {base: '10px', md: '10px'}, // 10px mobile, 10px desktop
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },
    blogTitle: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '16px', md: '20px'}, // 16px mobile, 20px desktop
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%',
      mb: 0,
    },
    blogTags: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 2, // 8px
    },
    blogTag: {
      display: 'flex',
      p: '4px 8px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 2.5, // 10px
      borderRadius: '32px',
      border: '1px solid',
      borderColor: 'brandColors.linen03', // #D6D2C5
    },
    blogTagText: {
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: '10px', md: '12px'}, // 10px mobile, 12px desktop
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
    },
  },
  variants: {
    default: {},
    related: {
      blogPost: {
        px: {base: 0, md: 0},
        pb: 0.25,
      },
    },
  },
};

export default BlogCard;
